class BrandAnnouncement {
  constructor() {
    this.query = window.matchMedia('(min-width: 750px)');
    this.sync = this.sync.bind(this);
    this.query.addEventListener('change', this.sync);
    this.sync();
  }

  bars() {
    return document.querySelectorAll('announcement-bar-component');
  }

  sync() {
    const wide = this.query.matches;

    this.bars().forEach((bar) => {
      if (wide) {
        if (bar.hasAttribute('autoplay')) {
          bar.dataset.brandAutoplay = bar.getAttribute('autoplay');
          bar.removeAttribute('autoplay');
        }
        bar.removeAttribute('aria-live');
        bar.querySelectorAll('.announcement-bar__slide').forEach((slide) => {
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('inert');
        });
      } else if (bar.dataset.brandAutoplay) {
        bar.setAttribute('autoplay', bar.dataset.brandAutoplay);
        bar.setAttribute('aria-live', 'polite');
      }
    });
  }
}

if (!window.__brandAnnouncement) {
  window.__brandAnnouncement = new BrandAnnouncement();
}
